<template>
	<div class="accordion">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'Accordion',
	mounted() {
		this.$children
			.filter(vm => vm.$accordionItem)
			.forEach((child, i, all) => {
				child.$on('open', open => {
					if (open) all.forEach((c, j) => (c.open = i === j))
					else child.open = false
				})
			})
	},
}
</script>
